import { render, staticRenderFns } from "./festivals.vue?vue&type=template&id=36caa9ed&scoped=true"
import script from "./festivals.vue?vue&type=script&lang=js"
export * from "./festivals.vue?vue&type=script&lang=js"
import style0 from "./festivals.vue?vue&type=style&index=0&id=36caa9ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36caa9ed",
  null
  
)

export default component.exports